// Sprint 35 item 1: one run of a mini-game, scored. Pure; imported by the server (to replay a player's trace) and by the page
// (to show the same number at once). A score a client sends is never read: the points are those of the replay of the trace.
import { miniPoints } from './balance.js';
import { gameOf } from './registry.js';

const isInt = v => Number.isInteger(v);
const BEAR_X = 152, BEAR_Y = 88; // touch target in box pixels plus 1; 0 = not touching

// The no-input value of one step.
// Bull Run and Hold the bags take one number a step (a lean, a tap); the bear's game takes a touch point.
const SCALAR = ['bull', 'holden'];
export const noInput = gameId => (SCALAR.includes(gameId) ? 0 : [0, 0]);

// A trace is one value per step, exactly the game's length. Anything else is rejected whole (score 0).
export function checkTrace(gameId, trace) {
  const game = gameOf(gameId);
  if (!game) return { ok: false, reason: 'no-game' };
  if (!Array.isArray(trace) && !ArrayBuffer.isView(trace)) return { ok: false, reason: 'bad-trace' };
  if (trace.length !== game.STEPS) return { ok: false, reason: 'bad-length' };
  for (const v of trace) {
    if (gameId === 'bull' || gameId === 'holden') {
      const lo = gameId === 'bull' ? -4 : 0, hi = gameId === 'bull' ? 4 : 1; // a lean in quarters, or a tap
      if (!isInt(v) || v < lo || v > hi) return { ok: false, reason: 'bad-value' };
    } else {
      if (!Array.isArray(v) || v.length !== 2 || !isInt(v[0]) || !isInt(v[1])) return { ok: false, reason: 'bad-value' };
      if (v[0] < 0 || v[0] > BEAR_X || v[1] < 0 || v[1] > BEAR_Y || (v[0] === 0) !== (v[1] === 0)) return { ok: false, reason: 'bad-value' };
    }
  }
  return { ok: true };
}

// A whole trace of no input is a run that never played: it scores as a skip.
export const isNoInput = (gameId, trace) => trace.every(v => (SCALAR.includes(gameId) ? v === 0 : v[0] === 0 && v[1] === 0));

// The reference loop: the game's own steps from step 0 until it ends.
export function replay(gameId, seed, trace, mode = 'bonus') {
  const game = gameOf(gameId);
  let s = game.init(seed, { mode });
  for (let t = 0; t < game.STEPS; t++) {
    s = game.step(s, t < trace.length ? trace[t] : noInput(gameId));
    if (game.result(s).over) break;
  }
  return game.result(s);
}

// What a run is worth. skip: the player pressed Skip, pressed Esc or left. Returns { points, played, reason, result }.
// `played` is true only for a real run (a valid trace with at least one input step before the game ended).
export function scoreRun({ gameId, seed, trace, mode = 'bonus', right, skip = false, sizes = null }) {
  const none = reason => ({ points: 0, played: false, reason, result: null });
  if (skip) return none('skip');
  const ok = checkTrace(gameId, trace);
  if (!ok.ok) return none(ok.reason);
  const result = replay(gameId, seed, trace, mode);
  if (isNoInput(gameId, Array.prototype.slice.call(trace, 0, result.steps))) return { ...none('no-input'), result }; // nothing touched before the end
  return { points: miniPoints({ guest: gameId, right, steps: result.steps, bags: result.bags, reachedEnd: result.reachedEnd, clean: result.clean, played: true, sizes }), played: true, reason: null, result };
}
